export default "__VITE_ASSET__CYQAd2SR__"